<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogSelectTechnicien" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable
                  >
            <v-card tile>
                <v-toolbar card dark color="primary">

                    <v-toolbar-title>Selectionner un technicien</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap>
                         <v-flex xs12>
                           <v-alert  :value="true" outline color="purple" icon="info">
                                    Veuillez selectionner un technicien pour une intervention de la demande DMD-{{demandeDetail.idDemande}}
                            </v-alert>
                        </v-flex>
                        <br/>

                        <v-flex xs12>

                            <el-table :data="listeTechniciens" style="width: 100%">
                                <el-table-column prop="nom" label="Nom et prenoms" sortable> </el-table-column>
                                <el-table-column prop="contact" label="Contact"> </el-table-column>
                                <el-table-column prop="specialite" label="Specialite"></el-table-column>
                                <el-table-column
                                    label="Operations">
                                    <template slot-scope="scope">
                                        <el-button
                                        size="mini"
                                        type="primary"
                                        :disabled="scope.row.status == 1"
                                        @click="submitTech(scope.row)">Selectionner</el-button>
                                    </template>
                                    </el-table-column>
                            </el-table>

                        </v-flex>
                    </v-layout>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "SelectionTechnicien",
        props:["show","listeTechniciens","demandeDetail"],
        data() 
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            loading: false,
            dialogSelectTechnicien: false,
         }    
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogSelectTechnicien = newValue
            }
        },

        methods: {
             closeDialog(){
                this.$emit('close')
            },
            submitTech(item){
                
                 this.loading = true
                
                let url = this.domaine + 'demande_maintenance/select/technicien'
                    item.idTechnicien
                 //recuperation des demandes
                 let data = new FormData();
                 data.append("idDemande",this.demandeDetail.idDemande)
                 data.append("idUser",this.user.id)
                 data.append("idTechnicien",item.idTechnicien) 
                
                 this.$http.post(url, data).then(response => {
                     this.closeDialog()
                     this.loading = false
                     this.successNotif("Une notification sms et mail a ete envoye au technicien "+item.nom)
                },
                (erreur) => {
                    this.closeDialog()
                     this.loading = false
                     this.$message.error("Une erreur est survenue lors de l'enregistrement du choix du technicien")
                })


            },
             successNotif(mess = ""){
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
            }
        },
        mounted(){
            
        }

    }
    </script>


// WEBPACK FOOTER //
// src/components/maintenance/SelectionTechnicien.vue